import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { RtcServiceController } from 'src/app/services/rtc.service';
import { CamButtonStateService } from './cam-button-state.service';

export const HIDE_MYSELF_CONTAINER_ID = 'hideMyself-container';

@Injectable()
export class HideSelfVideoButtonStateService {
  constructor(
    private camButtonStateService: CamButtonStateService,
    private translateService: TranslateService,
    private rtcServiceController: RtcServiceController,
  ) {}

  showButton$ = this.camButtonStateService.isCamOpen$;

  active$: Observable<boolean> = this.rtcServiceController.hideSelfViewActive$;

  label$ = this.active$.pipe(
    map((active) => {
      if (active) {
        return this.translateService.instant('Show self view');
      } else {
        return this.translateService.instant('Hide self-video');
      }
    }),
  );

  get active() {
    return this.rtcServiceController.hideSelfViewActive;
  }

  toggleShowSelfVideo() {
    this.rtcServiceController.toggleShowSelfVideo();
  }

  // Used for turning off/resetting hide self view
  resetHideSelfViewState() {
    this.rtcServiceController.resetHideSelfViewState();
  }
}
